import type React from 'react';

import { getTranslatedString } from '@/utils';

export const getFormItemLabel = (i18nLabel: string, label: React.ReactNode) => {
  return i18nLabel ? getTranslatedString(i18nLabel) : label;
};
